import mobile_metadata from "libphonenumber-js/metadata.mobile.json";
import { useControlled } from "@commonlibs";
import { PhoneCountryCodeSelectProps } from "../PhoneCountrySelect.types";
import { useEffect } from "react";
import { getCountryCallingCode } from "libphonenumber-js";
import { SelectOption } from "@commonlibs";

const countryCodeOptions = Object.keys(mobile_metadata.country_calling_codes).map((code) => ({
    label: `+${code}`,
    value: code,
}));

export interface PhoneCountryCodeSelectComps {
    value: string | undefined;
    setValue: (value: string | undefined) => void;
    display: string;
    options: SelectOption<string>[];
}

export default function usePhoneCountryCodeSelect({
    country,
    defaultValue,
    value: valueProp,
    onChange,
}: PhoneCountryCodeSelectProps): PhoneCountryCodeSelectComps {
    const [value, setValue] = useControlled(defaultValue, valueProp, onChange);

    useEffect(() => {
        if (country) setValue(getCountryCallingCode(country));
    }, [country]);

    return {
        value,
        setValue,
        display: value ? `+${value}` : "",
        options: countryCodeOptions,
    };
}
